import { createSelector } from "reselect";
import { State } from "../state";

export function getIpPhoneState(state: State) {
  return state.ipPhone;
}

export const getIsPhoneCall = createSelector(getIpPhoneState, ae => ae.isPhoneCall);

export const getCallSid = createSelector(getIpPhoneState, ae => ae.callSid);

export const getIncomingCallStatus = createSelector(getIpPhoneState, ae => ae.incomingCallStatus);

export const getDeviceStatus = createSelector(getIpPhoneState, ae => ae.deviceStatus);

export const getIpPhoneToken = createSelector(getIpPhoneState, ae => ae.ipPhoneToken);

export const getCallRoom = createSelector(getIpPhoneState, ae => ae.callRoom);

export const getIpPhoneSettings = createSelector(getIpPhoneState, ae => ae.settings);

export const getPhoneContacts = createSelector(getIpPhoneState, ae => ae.settings?.contacts);

export const getIsUpdatingSettings = createSelector(getIpPhoneState, ae => ae.isUpdatingSettings);

export const getMakeCallNumber = createSelector(getIpPhoneState, ae => ae.makeCallNumber);
